import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { inputTitleClass } from './styles';

var InputTitle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputTitle, _PureComponent);

  var _super = _createSuper2(InputTitle);

  function InputTitle(props) {
    var _this;

    _classCallCheck(this, InputTitle);

    _this = _super.call(this, props);
    _this.state = {
      animation: false
    };
    _this.stopAnimation = _this.stopAnimation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputTitle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        this.startAnimation();
      }
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      this.setState({
        animation: true
      });
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      this.setState({
        animation: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          innerTitle = _this$props.innerTitle,
          className = _this$props.className,
          style = _this$props.style,
          children = _this$props.children,
          open = _this$props.open,
          titleClass = _this$props.titleClass,
          contentClass = _this$props.contentClass,
          placeTitle = _this$props.placeTitle;
      if (!innerTitle) return children;
      var animation = this.state.animation;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: classnames(inputTitleClass('_', open && 'open', animation && 'animation'), className)
        },
        /*#__PURE__*/
        React.createElement("div", {
          onAnimationEnd: this.stopAnimation,
          className: classnames(inputTitleClass('title', 'top'), titleClass)
        }, innerTitle),
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(contentClass, inputTitleClass('content'))
        }, children),
        /*#__PURE__*/
        React.createElement("div", {
          onAnimationEnd: this.stopAnimation,
          className: inputTitleClass('place')
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(inputTitleClass('title'))
        }, placeTitle || innerTitle)))
      );
    }
  }]);

  return InputTitle;
}(PureComponent);

export default InputTitle;